import React from 'react';

export const PartnerSection = () => {
  const partners = [
    { name: 'Musik i Gentofte', logo: '/mig-logo.png', url: 'https://www.musikigentofte.dk', rounded: true },
    { name: 'Festicon', logo: '/festicon-logo.png', url: 'https://www.festicon.dk', needsDark: true },
    { name: 'S5', logo: '/s5-logo.avif', url: 'https://s5.dk' },
    { name: 'PAX', logo: '/pax-logo.png', url: 'https://www.paxtechnology.com' },
    { name: 'EIFO', logo: '/EIFO.jpg.webp', url: 'https://eifo.dk' },
    { name: 'Folkets Hus', logo: '/folketshus.png', url: 'https://folketshus.struer.dk' },
    { name: 'SoundHub', logo: '/soundhub.png', url: 'https://soundhub.dk' },
  ];

  const duplicatedPartners = [...partners, ...partners];

  const renderPartnerLogo = (partner, index) => {
    const logo = partner.needsDark ? (
      <div className="bg-primary/90 rounded-lg px-4 py-2">
        <img
          src={partner.logo}
          alt={partner.name}
          className={`h-16 w-auto max-w-[140px] object-contain ${partner.rounded ? 'rounded-lg' : ''}`}
        />
      </div>
    ) : (
      <img
        src={partner.logo}
        alt={partner.name}
        className={`h-16 w-auto max-w-[140px] object-contain ${partner.rounded ? 'rounded-lg' : ''} opacity-80 hover:opacity-100 transition-opacity`}
      />
    );

    if (!partner.url) {
      return (
        <div
          key={`${partner.name}-${index}`}
          data-testid={`partner-logo-${index}`}
          className="flex h-24 min-w-[180px] items-center justify-center px-6"
        >
          {logo}
        </div>
      );
    }

    return (
      <a
        key={`${partner.name}-${index}`}
        data-testid={`partner-logo-${index}`}
        href={partner.url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex h-24 min-w-[180px] items-center justify-center px-6"
      >
        {logo}
      </a>
    );
  };

  return (
    <section data-testid="partner-section" className="py-16 md:py-20 bg-section-bg">
      <div className="container-custom">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-3">
            Vi samarbejder med
          </h2>
          <p className="text-body-text">
            MUSEIQ samarbejder med arrangører og teknologipartnere for at levere stabile løsninger til live events.
          </p>
        </div>

        <div className="relative overflow-hidden">
          <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r from-section-bg to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-section-bg to-transparent" />

          <div className="partner-marquee">
            <div className="partner-marquee-track">
              {duplicatedPartners.map((partner, index) => renderPartnerLogo(partner, index))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
